import { AccountBalance, Currency } from "@wingspanhq/wingspan-api-sdk";

export type AccountBalanceAmounts = {
  balance: number;
  available: number;
  hold: number;
  pending: number;
  currency: Currency;
};

// The v3 AccountBalance returns its amounts as strings; consumers feed them to
// formatMoney / numeric comparisons, so coerce to numbers here at the boundary.
// Undefined-tolerant so call sites keep the `data && ...` ergonomics they had
// when the v1 balance fields were already numeric. The currency flows through as
// the SDK Currency — formatMoney / WSInputNumber accept it directly.
export const selectorAccountBalance = (
  accountBalance?: AccountBalance
): AccountBalanceAmounts => ({
  balance: Number(accountBalance?.balance ?? 0),
  available: Number(accountBalance?.available ?? 0),
  hold: Number(accountBalance?.hold ?? 0),
  pending: Number(accountBalance?.pending ?? 0),
  currency: accountBalance?.currency ?? Currency.USD
});
